<template>
  <div class="Hdr-Profile">
    <HeaderUserMenu class="Hdr-Profile__menu" v-if="get_isAuth"/>
    <template v-if="!get_isAuth">
      <ButtonMain :type="'primary'" fontSize="14px" radius="24px" height="36px" @click="toOpen" v-if="!isLessThanMD">Войти</ButtonMain>
      <button class="Hdr-Profile__adaptive-btn" @click="toOpen" v-else>
        <DoorIcon />
      </button>
    </template>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  import { useScreenSize } from '@shared/composables/screenWidth/useScreenSize';
  //----------------------------
  import ButtonMain from '@ui/Buttons/ButtonMain/ButtonMain';
  import DoorIcon from '@shared/UI/SVG/DoorIcon.vue';
  import HeaderUserMenu from './components/HeaderUserMenu/HeaderUserMenu.vue';
  //----------------------------
  const store = useStore();
  //----------------------------
  const { isLessThanMD } = useScreenSize();
  //----------------------------
  //Авторизован ли пользователь
  const get_isAuth = computed(() => store.state.UserSystem.user.isAuthenticated);
  //----------------------------
  //Открыть виджет
  const toOpen = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_LOGIN);
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.auth);
  }
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>